import React from 'react';
import classnames from 'classnames';
import { useBreakpoints } from '@fiverr-private/business_blocks';
import { ProfileHeader } from '@fiverr-private/seller_pages_toolbox';
import { useRolloutContext } from '../../../../contexts/RolloutContext';
import { UrlContext } from '../../../../utils';

import classes from './index.module.scss';

/** @type {import('./index').ModalHeader} */
export const ModalHeader = ({ className, onRatingsClick }) => {
    const { inQualasNewLevelSystemRollout } = useRolloutContext();
    const { isMD } = useBreakpoints();
    const avatarSize = isMD ? 96 : 48;
    const onlineIndicatorSize = isMD ? 12 : 8;
    const isFiverrChoice = UrlContext.isFiverrChoice();

    return (
        <ProfileHeader
            className={classnames(className, 'flex')}
            avatarSize={avatarSize}
            withGeographicalData={isMD}
            isInModal
            ratingsClassName={classes.mobileHeader}
            withOneLiner={isMD}
            onlineIndicatorSize={onlineIndicatorSize}
            isFiverrChoice={isFiverrChoice}
            onRatingsClick={onRatingsClick}
            disableIntroVideo
            showSellerLevelNewBadges={inQualasNewLevelSystemRollout}
        />
    );
};
